import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';

import Browser from '@wetransfer/concorde-browser';
import Router from '@module/router';
import I18n from '@module/i18n';
import LaunchDarkly from '@module/launchdarkly';

import Actions from '@app/action';

import Icon from '@component/icon';

import { EXPERIMENT_SEND_FEEDBACK } from '@constant/experiments';

import Upsell from './upsell';

export class Complete extends React.PureComponent {
  state = {
    upsell: false,
  };

  displayUpsell = () => {
    const { user } = this.props;

    if (user.loggedIn) {
      this.newTransfer();
    } else {
      this.setState({ upsell: true });
    }
  };

  newTransfer = () => {
    this.props.createTransfer();
    Router.navigateTo('/');
  };

  getShortcut() {
    const identity = Browser.identity;

    // Get the shortcut to display current downloads in platform/browser
    if (Browser.platform('Win|Windows')) {
      switch (identity.browser) {
        case 'Chrome':
        case 'Firefox':
        case 'Explorer':
          return 'control_j'; // IE 9+

        case 'Safari':
          return 'control_alt_l';
      }
    } else if (Browser.platform('Mac')) {
      switch (identity.browser) {
        case 'Chrome':
          return 'cmd_shift_j';
        case 'Firefox':
          return 'cmd_j';
        case 'Safari':
          return 'cmd_alt_l';
      }
    }

    return null;
  }

  handleSendReplyClick = () => {
    this.props.showFeedback();

    window.__snowplow__ &&
      window.__snowplow__(
        'trackStructEvent:co',
        'feedback',
        'click_send_a_reply'
      );
  };

  // Render our view
  render() {
    const {
      transfer: { state: transferState, showFeedback },
      feedbackSent,
    } = this.props;

    const shouldShowFeedback =
      showFeedback &&
      !feedbackSent &&
      LaunchDarkly.getVariant(EXPERIMENT_SEND_FEEDBACK);

    const isFeedbackComplete = transferState === 'feedbackComplete';

    const shortcut = this.getShortcut();
    let downloadText = null;

    if (shortcut) {
      downloadText = I18n.t('transfer.downloaded.text', {
        shortcut: I18n.t(`shortcuts.${shortcut}`),
      });
    }

    let actionLabel = I18n.t('transfer.buttons.new_transfer');
    if (Browser.isMobile) {
      actionLabel = I18n.t('transfer.buttons.back_to_home');
    }

    if (this.state.upsell) {
      return <Upsell onContinue={this.newTransfer} />;
    }

    const title = isFeedbackComplete
      ? "You're done"
      : I18n.t('transfer.downloaded.title');

    const feedbackText = isFeedbackComplete && <p>Your reply has been sent.</p>;

    const text = !isFeedbackComplete && downloadText && (
      <p dangerouslySetInnerHTML={{ __html: downloadText }} />
    );

    const downloaderCompleteClassName = classnames('downloader__complete', {
      'downloader__complete--feedback':
        shouldShowFeedback && !isFeedbackComplete,
    });

    return (
      <div className="transfer__window downloader">
        <div className="transfer__contents">
          <div className={downloaderCompleteClassName}>
            <Icon type="TransferComplete" className="downloader__image" />
            <h2>{title}</h2>
            {text}
            {feedbackText}
            {shouldShowFeedback && !isFeedbackComplete && (
              <button
                className="transfer__button--secondary"
                onClick={this.displayUpsell}
              >
                {actionLabel}
              </button>
            )}
          </div>
        </div>
        <div className="transfer__footer">
          {!Browser.isMobile ? (
            <Icon
              type="TransferBack"
              className="transfer__back"
              onClick={this.props.resetDownload}
            />
          ) : null}
          {shouldShowFeedback && !isFeedbackComplete && (
            <button
              onClick={this.handleSendReplyClick}
              className="transfer__button"
            >
              Send a reply
            </button>
          )}
          {(!shouldShowFeedback || isFeedbackComplete) && (
            <button className="transfer__button" onClick={this.displayUpsell}>
              {actionLabel}
            </button>
          )}
        </div>
      </div>
    );
  }
}

Complete.propTypes = {
  transfer: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  resetDownload: PropTypes.func.isRequired,
  createTransfer: PropTypes.func.isRequired,
  showFeedback: PropTypes.func.isRequired,
  feedbackSent: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ user, transfer, ui }) => ({
  user,
  transfer,
  feedbackSent: ui.feedbackSent,
});

const mapDispatchToProps = {
  resetDownload: Actions.Transfer.resetDownload,
  createTransfer: Actions.Transfer.create,
  showFeedback: Actions.Transfer.showFeedback,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Complete);
